import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center h-screen w-full bg-gray-50">
      <div className="relative">
        {/* Outer ring */}
        <div className="w-16 h-16 rounded-full border-4 border-indigo-200 border-t-indigo-600 animate-spin"></div>
        
        {/* Inner ring */}
        <div className="absolute top-1 left-1 w-14 h-14 rounded-full border-4 border-teal-200 border-b-teal-500 animate-[spin_1.5s_linear_infinite]"></div>
        
        {/* Center dot */}
        <div className="absolute top-6 left-6 w-4 h-4 rounded-full bg-indigo-600 animate-pulse"></div>
      </div>
      
      {/* Loading text */}
      <div className="ml-4 text-lg font-medium text-gray-700 animate-pulse">
        Chargement...
      </div>
    </div>
  );
};

export default LoadingSpinner;